import { IsEmail } from 'class-validator'
import { FormModel } from 'submodules/nerit-framework-ui/common/form-state-manager/types/FormModel'
import { ObjectPropsTP } from 'submodules/nerit-framework-utils/utils/types/ObjectPropsTP'
import { IsRequired } from 'submodules/nerit-framework-utils/validators'

export class RecoverAccessFormModel extends FormModel {

    @IsRequired()
    @IsEmail()
    email: string

    constructor(initialData?: ObjectPropsTP<RecoverAccessFormModel>) {
        super(initialData)
        Object.assign(this, initialData)
    }
}
